/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

export const GRIDSCROLLLINK_INIT = 'GRIDSCROLLLINK_INIT';
export const initialiseGridScrollLink = (scrollLinkId, position) => ({
  type: GRIDSCROLLLINK_INIT,
  scrollLinkId,
  position,
});

export const GRIDSCROLLLINK_CLEANUP = 'GRIDSCROLLLINK_CLEANUP';
export const cleanupGridScrollLink = (scrollLinkId) => ({ type: GRIDSCROLLLINK_CLEANUP, scrollLinkId });

export const GRIDSCROLLLINK_SET_POSITION = 'GRIDSCROLLLINK_SET_POSITION';
export const setGridScrollLinkPosition = (id, scrollLinkId, position) => ({
  type: GRIDSCROLLLINK_SET_POSITION,
  id,
  scrollLinkId,
  position,
});
